<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/X6rYba/tc-custom/9781453293027.jpg?1704292314523" alt="This image is the cover for the book Festival of Deaths, The Gregor Demarkian Holiday Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Festival of Deaths, The Gregor Demarkian Holiday Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>When a killer stalks a provocative talk show host, ex-FBI agent Gregor Demarkian is the next guest in this mystery from the author of <i>Quoth the Raven</i>.</b><br/>  Sex, sex, and more sex—this is the formula for a hit talk show. No one knows this better than Lotte Goldman, host of television’s most outrageous chat show, but even she is getting bored of her sensational interviews. To break the routine, she and her producer—the towering, dynamic DeAnna Kroll—take the show to Philadelphia to film a conversation between ex-FBI agent Gregor Demarkian and a convicted serial killer. But before they hit the road, a murder hits them. Lotte’s talent coordinator is found dead in a closet, her face battered beyond recognition, and a second victim appears soon after they arrive in Philadelphia. To save the most popular woman on TV, Demarkian leaps into a cat-and-mouse game so twisted that it’s perfect for premium cable.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jane Haddam
      </h2>
      
      <p class="authorDescription body article">Jane Haddam (1951&ndash;2019) was an American author of mysteries. Born Orania Papazoglou, she worked as a college professor and magazine editor before publishing her Edgar Award&ndash;nominated first novel, <I>Sweet, Savage Death</I>, in 1984. This mystery introduced Patience McKenna, a sleuthing scribe who would go on to appear in four more books, including <I>Wicked, Loving Murder</I> (1985) and <I>Rich, Radiant Slaughter</I> (1988).<BR /> &#160;<BR /><I>Not a Creature Was Stirring </I>(1990) introduced Haddam&rsquo;s best-known character, former FBI agent Gregor Demarkian. The series spans more than twenty novels, many of them holiday-themed, including <I>Murder Superior </I>(1993), <I>Fountain of Death</I> (1995), and <I>Wanting Sheila Dead</I> (2005). Haddam&rsquo;s later novels include <I>Blood in the Water</I> (2012) and <I>Hearts of Sand</I> (2013).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c553e1a0